import type { proposalsApi } from 'app/src/services/welfareportal'

export const mockProposalsCategories: proposalsApi.ProposalsCategories = {
  categories: [
    { id: '1', productCategory: 'ARREDAMENTO E GIARDINO' },
    { id: '2', productCategory: 'ASILI E BABY SITTING' },
    { id: '3', productCategory: 'ATTREZZATURE SPORTIVE' },
    { id: '4', productCategory: 'CARBURANTE' },
    { id: '5', productCategory: 'CASA E MANUTENZIONE' },
    { id: '6', productCategory: 'CENTRI COMMERCIALI E OUTLET' },
    { id: '7', productCategory: 'CINEMA' },
    { id: '8', productCategory: 'CULTURA E CORSI DI FORMAZIONE' },
    { id: '9', productCategory: 'E-COMMERCE' },
    { id: '10', productCategory: 'FARMACI E PRESIDI SANITARI' },
    { id: '11', productCategory: 'FOOD AND BEVERAGE' },
    { id: '12', productCategory: 'GIFT CARD PER TRAVEL' },
    { id: '13', productCategory: 'GIORNALI E MAGAZINE' },
    { id: '14', productCategory: 'INFANZIA' },
    { id: '15', productCategory: 'LENTI PER LA VISTA E MONTATURE' },
    { id: '16', productCategory: 'LIBRERIA E PRODOTTI EDITORIALI' },
    { id: '17', productCategory: "MOBILITA'" },
    { id: '18', productCategory: 'NEGOZI RIVENDITORI BEAUTY CARE' },
    { id: '19', productCategory: 'NEGOZI RIVENDITORI ELETTRONICA' },
    { id: '20', productCategory: 'NEGOZI RIVENDITORI FASHION STYLE' },
    { id: '21', productCategory: 'PARCHI TEMATICI ED EVENTI' },
    { id: '22', productCategory: 'PETS' },
    { id: '23', productCategory: 'PRESTAZIONI SANITARIE' },
    { id: '24', productCategory: 'RISTORAZIONE' },
    { id: '25', productCategory: 'SERVIZI AMMINISTRATIVI E DIGITALI' },
    { id: '26', productCategory: 'SERVIZI SOCIO ASSISTENZIALI' },
    { id: '27', productCategory: 'SPORT' },
    { id: '28', productCategory: 'SUPERMERCATI E SPESA' },
    { id: '29', productCategory: 'TEMPO LIBERO ED EXPERIENCE' },
    { id: '30', productCategory: 'TESTI SCOLASTICI' },
    { id: '31', productCategory: 'VIAGGI E HOTEL' },
    { id: '32', productCategory: 'VIDEOGAMES, GIOCHI E GIOCATTOLI' },
    { id: '33', productCategory: 'WELLNESS' },
  ],
}

export const mockProposalsDocuments: proposalsApi.DocumentPaginated = {
  items: [
    {
      documentId: '1',
      name: 'Programma Welfare Suggerimento Convenzioni Elenco Categorie.pdf',
      url: '/pdf/Programma_Welfare_Suggerimento_Convenzioni_Elenco_Categorie.pdf',
      type: 'pdf',
    },
  ],
  total: 1,
  limit: 10,
  offset: 0,
}
